import { DotsThreeOutlineVerticalIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MenuBullet = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <DotsThreeOutlineVerticalIcon {...rest} size={Sizes[size]} color={fill} />;
};

MenuBullet.displayName = 'MenuBullet';
